const options = {
    item: 'js-redirect-modal',
    close: 'js-close',
    dialog: 'js-redirect-modal__dialog',
}

const redirectPopup = {
    init() {
        const item = document.getElementsByClassName(options.item);
        const modals = [...item];

        modals.forEach((modal) => {
            const dialog = modal.getElementsByClassName(options.dialog);
            const closeBtn = modal.getElementsByClassName(options.close);
            const closeBtns = [...closeBtn];

            dialog[0].setAttribute('open', true);

            closeBtns.forEach((close) => {
                close.addEventListener('click', (e) => {
                    const target = e.target;

                    target.closest(`.${options.item}`).classList.remove('active');
                });
            });
        });

    }
}

export default redirectPopup;
